import { Injectable } from '@angular/core';
import { IArchivoAdjunto, IArchivoAdjuntoFirma, IGetInitialDataSign, ISolicitudFirma } from '../interface/sign.interface';
import { HttpGeneric } from '@/models/class/httpGeneric';
import { IResponseApiGeneric } from '@/interface/general/IResponseApi';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataSignService extends HttpGeneric<string | number> {
  // Para firmas
  private urlGetInitialDataSign = 'Firmas/GetInitialDataFlujoDoc';
  private urlPostFirmarVistaPrevia = 'FlujoDocRad/FirmarVistaPrevia';
  private urlPostFirmar = 'FlujoDocRad/FlujoDocRadFirmarFinalizarDoc';
  
  // Archivos
  getFile(url: string) {
    return this.httpService.Get<IResponseApiGeneric<IArchivoAdjuntoFirma>>(url, true)
      .pipe(map((resp) => resp.data));
  }

  // Firmas
  getGetInitialDataSign(Clasificacion: string, CodGlobal: string): Observable<IGetInitialDataSign> {
    return this.httpService.Get<IResponseApiGeneric<IGetInitialDataSign>>(
      `${this.urlGetInitialDataSign}?Clasificacion=${Clasificacion}&CodGlobal=${CodGlobal}`
    ).pipe(map((resp) => resp.data));
  }

  postFirmarVistaPrevia(request: ISolicitudFirma): Observable<IArchivoAdjunto> {
    return this.httpService.Post<IResponseApiGeneric<IArchivoAdjunto>>(
      request, this.urlPostFirmarVistaPrevia      
    ).pipe(map((resp) => resp.data));
  }  
  
  postFirmar(request: ISolicitudFirma): Observable<IArchivoAdjunto> {
    return this.httpService.Post<IResponseApiGeneric<IArchivoAdjunto>>(
      request, this.urlPostFirmar      
    ).pipe(map((resp) => resp.data));
  }
}
